import { MeetingType } from "./meetingTypeToTranslationKey";

const DEFAULT_MEETING_COLOR = "black";

const MEETING_TYPE_COLORS: Record<MeetingType, string> = {
  VISIT: "#f54758",
  TAKING_MEASUREMENTS: "#ad7611",
  FIRST_MEASUREMENT: "#12ad27",
  SECOND_MEASUREMENT: "#4899ad",
  OTHER: "#bebebf",
  CONTRACT: "#ffff5b",
  RECEIVING: "#ad579f",
  WAITING_LIST: "#CFE2F3",
  NOTE: "#bebebf",
  SECOND_MEASUREMENT_AND_RECEIVING: "#fdeb92",
  SECOND_VISIT: "#e67e22",
  THIRD_VISIT: "#c0392b",
  CONSULTING_SERVICES: "#8e44ad",
};

export const getMeetingColor = (type: MeetingType) => {
  return MEETING_TYPE_COLORS[type] ?? DEFAULT_MEETING_COLOR;
};
